// removed by extract-text-webpack-plugin
module.exports = {"container":"_3C22DSI","notificationContainer":"_1FUcAu2","link":"_1U-LQGT","MyAccount":"CbK3vyi","MyAccountHalloween":"_2lOexWR","MyOrders":"sEG4Jt8","ReturnsInformation":"gWnk_r7","ContactPreferences":"lWdTQ9X"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MyAccountLinks/index.css
// module id = ./template/components/MyAccountLinks/index.css
// module chunks = client.sitechrome